export enum ScheduleStatusEnum {
  SCHEDULED = 'Agendado',
  PRESENT = 'Presente',
  MARKED = 'Marcado',
  WAITING = 'Aguardando',
  ATTENDED = 'Atendido',
  CANCELLED = 'Cancelado'
}
